import React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { useNavigate, useSearchParams } from "react-router-dom";
import Utils from "../../utils.js";
import SettingHeader from "../admin/setting-header.jsx";
import { CreateCompanySchema } from "../admin/validator.js";
import { Formik } from "formik";
import Loader from "../../components/loader/index.jsx";
import { useSnackbar } from "../../components/toast/index.jsx";
import { Box, Grid, Paper, Typography } from "@mui/material";
import { COMPANY_UPDATED_FAILED, COMPANY_UPDATED_SUCCESS } from "../../helpers/messages.js";

function EditCompanyComponent() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [companyId] = React.useState(params.get("id") || "");
  const [data, setData] = React.useState([]);
  const [selectedTab] = React.useState("Companies");
  const [dataLoaded, setDataLoaded] = React.useState(false);
  const [spinner, setSpinner] = React.useState(false);
  const showSnackbar = useSnackbar();

  async function getCompanyData() {
    Utils.sendProgressBar(true);
    let user = await Utils.getUserGroupFromCognito();
    if (user.find((z) => z === "admin") === null) navigate("/");
    else {
      let company = await Utils.genericGet("getCompany", companyId);
      company = company.data.getCompany;
      setData(company);
    }
    setSpinner(false);
  }

  const initialValues = {
    name: data.name || "",
    contact: data.contact || "",
    email: data.email || ""
  }

  React.useEffect(() => {
    if (!dataLoaded) {
      const fetchData = async () => {
        setSpinner(true);
        await getCompanyData(); // Your async data fetching function
        setDataLoaded(true); // Mark data as loaded
      };
      fetchData();
    }
    window.scrollTo(0, 0); // Scroll to top when component mounts
  }, [dataLoaded]);


  const submitForm = async (values, { setSubmitting }) => {
    Utils.sendProgressBar(true);
    setSubmitting(true);
    setSpinner(true);
    try {
      await Utils.genericMutation("updateCompany", {
        id: data.id,
        name: values.name,
        contact: values.contact,
        email: values.email,
      });
      getCompanyData();
      setSubmitting(false);
      showSnackbar(COMPANY_UPDATED_SUCCESS);
    } catch (error) {
      setSubmitting(false);
      setSpinner(false);
      showSnackbar(COMPANY_UPDATED_FAILED, "error");
    }
  }

  return (
    <Grid display="flex" flexDirection="column" flexGrow="1" overflow="auto">
      {spinner && <Loader />}
      <SettingHeader title={"Companies"} selectedTab={selectedTab} />
      <Grid
        className="vocalysed-home-upadted setting-companies-edit"
        container
        spacing={0}
        direction="column"
        flexWrap="nowrap"
        flexGrow={1}
        paddingTop={2}
        paddingX={3}
        paddingBottom={3}
        overflow="auto"
      >
        <Paper
          sx={{display: "flex", flexDirection: "column", flexGrow: 1, width: '100%',  borderRadius: 2.5, padding: 3, boxSizing: "border-box" }}
        >
          <Formik
            enableReinitialize
            validationSchema={CreateCompanySchema}
            initialValues={initialValues}
            onSubmit={(values, actions) => {
              submitForm(values, actions);
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              errors,
              touched,
              isSubmitting,
            }) => (
              <Box
                component="form"
                noValidate
                onSubmit={handleSubmit}
                overflow="auto"
              >
                <Grid container spacing={2} sx={{ border: 0 }}>
                  <Grid item xs={12}>
                    <Typography variant="h6" component="div" sx={{ fontWeight: 600 }}>
                      Company Details
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} lg={4} xl={3}>
                    <TextField
                      fullWidth
                      id="outlined-basic"
                      variant="outlined"
                      label="Company Name"
                      required
                      name={"name"}
                      value={values.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.name && !!errors.name}
                      helperText={touched.name ? errors.name : ""}
                      disabled={isSubmitting}
                    />
                  </Grid>

                  <Grid item xs={12} sx={{marginTop: 1}}>
                    <Typography variant="h6" component="div" sx={{ fontWeight: 600 }}>
                      Admin Details
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} lg={4} xl={3}>
                    <TextField
                      fullWidth
                      id="outlined-basic"
                      variant="outlined"
                      label="Contact Name"
                      required
                      name={"contact"}
                      value={values.contact}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.contact && !!errors.contact}
                      helperText={touched.contact ? errors.contact : ""}
                      disabled={isSubmitting}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} lg={4} xl={3}>
                    <TextField
                      fullWidth
                      id="outlined-basic"
                      variant="outlined"
                      label="Email"
                      required
                      name={"email"}
                      value={values.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.email && !!errors.email}
                      helperText={touched.email ? errors.email : ""}
                      disabled={isSubmitting}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      variant="contained"
                      type="submit"
                      disabled={isSubmitting}
                      size="large"
                    >
                      {isSubmitting ? "Saving Changes..." : "Save Changes"}
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            )}
          </Formik>
        </Paper>
      </Grid>
    </Grid>
  );
}

export default EditCompanyComponent;
